import { render, staticRenderFns } from "./LinkReuseIds.vue?vue&type=template&id=4e0e10e0"
import script from "./LinkReuseIds.vue?vue&type=script&lang=js"
export * from "./LinkReuseIds.vue?vue&type=script&lang=js"
import style0 from "./LinkReuseIds.vue?vue&type=style&index=0&id=4e0e10e0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports